export const skillsData = [
    {
      label: "FRONT END",
      data: [
        {
          skillName: "React JS",
          percentage: "75",
        },
        {
          skillName: "CSS",
          percentage: "50",
        },
        {
          skillName: "JAVASCRIPT",
          percentage: "80",
        },
      ],
    },
    {
      label: "BACK END",
      data: [
        {
          skillName: "NODE JS",
          percentage: "70",
        },
        {
          skillName: "PYTHON",
          percentage: "30",
        },
        {
          skillName: "PHP",
          percentage: "40",
        },
      ],
    },
    {
      label: "DATABASES",
      data: [
        {
          skillName: "SQL",
          percentage: "70",
        },
        {
          skillName: "MONGO DB",
          percentage: "65",
        },
        {
          skillName: "PHP MyAdmin",
          percentage: "50",
        },
      ],
    },
    {
      label: "PROGRAMMING",
      data: [
        {
          skillName: "C",
          percentage: "50",
        },
        {
          skillName: "C++",
          percentage: "90",
        },
        {
          skillName: "PYTHON",
          percentage: "50",
        },
      ],
    },
    {
      label: "TOOLS",
      data: [
        {
          skillName: "Git/Github",
          percentage: "60",
        },
        {
          skillName: "VS Code",
          percentage: "70",
        },
        {
          skillName: "Latex",
          percentage: "20",
        },
      ],
    },
  ];